import { isAllowedPartner, UNAUTHORIZED_PARTNER_MESSAGE } from "constants/access";
import api from "./api";
import TokenService from "./token.service";

const rejectUnauthorizedPartner = () => {
  TokenService.removeUser();
  const error = new Error(UNAUTHORIZED_PARTNER_MESSAGE);
  error.code = "UNAUTHORIZED_PARTNER";
  throw error;
};

export const login = async (email, password, otp) => {
  const response = await api.post("/v1/cp/auth/login-with-otp", {
    email,
    password,
    otp,
  });
  if (response?.token) {
    TokenService.setUser(response.token);
  }

  try {
    const profile = await getProfile();
    if (!isAllowedPartner(profile)) {
      rejectUnauthorizedPartner();
    }
  } catch (err) {
    if (err?.code !== "UNAUTHORIZED_PARTNER") {
      TokenService.removeUser();
    }
    throw err;
  }

  return response;
};

export const sendLoginOtp = async (email, password) => {
  return api.post("/v1/cp/auth/send-login-otp", { email, password });
};

export const sendActionOtp = async (actionType) => {
  return api.post("/v1/cp/auth/send-action-otp", { actionType });
};

export const getProfile = async () => {
  return api.get("/v1/cp/auth/profile");
};

export const logout = () => {
  TokenService.removeUser();
  return;
};

export const getConstants = async () => {
  return api.get("/v1/config/constants");
};

export const sendForgetPasswordOtp = async (email,accountNo) => {
  return api.post("/v1/cp/auth/send-change-password-otp", { email, accountNo });
};
export const changePasswordByOtp = async (params) => {
  return api.post("/v1/cp/auth/change-password-otp-cp", params);
};

export const passwordResetLink = async (accountNo) => {
  return api.post("/v1/cp/auth/send-password-reset-link", {accountNo});
}

export const changePasswordByResetLink = async (params) => {
  return api.post("/v1/cp/auth/password-reset", params);
}